import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const TAB_SEARCH_PARAM_KEYS = {
	"/tracks": "track",
	"/event": "eventTab",
};

const isPageTabChange = (prevLocation, location) => {
	if (!prevLocation || prevLocation.pathname !== location.pathname) {
		return false;
	}

	const searchParamKey = TAB_SEARCH_PARAM_KEYS[location.pathname];
	if (!searchParamKey) return false;

	const prevSearchParams = new URLSearchParams(prevLocation.search);
	const nextSearchParams = new URLSearchParams(location.search);
	const prevTabRef = prevSearchParams.get(searchParamKey);
	const nextTabRef = nextSearchParams.get(searchParamKey);

	prevSearchParams.delete(searchParamKey);
	nextSearchParams.delete(searchParamKey);

	return (
		prevTabRef !== nextTabRef &&
		prevSearchParams.toString() === nextSearchParams.toString()
	);
};

const ScrollToTop = () => {
	const location = useLocation();
	const prevLocationRef = useRef(null);

	useEffect(() => {
		const prevLocation = prevLocationRef.current;
		const shouldKeepScrollPosition = isPageTabChange(prevLocation, location);

		prevLocationRef.current = location;

		// 페이지 내부 Tabs 전환은 현재 스크롤 위치를 유지한다.
		if (shouldKeepScrollPosition) return;

		window.scrollTo(0, 0);
	}, [location]);
	return null;
};

export default ScrollToTop;
